import logo from "./logo.svg";
import "./App.css";
import Header from "./Components/Header/Header";
import DataForm from "./Components/DataForm/DataForm";
import Footer from "./Components/Footer/Footer";

function App() {
  return (
    <div className="App">
      <Header />
      <DataForm />
      <Footer />
    </div>
  );
}

export default App;
